/**
 * @render react
 * @name Digiteka
 */

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';

import { withPolaris } from 'Components/protons/Polaris';

import './_style.scss';

/**
 * Commercial Video Player component
 * Please note: Our current provider is Exco,
 * but this component is named Digiteka which was the previous provider.
 *
 * @param {string} id
 * @returns
 */
const Digiteka = ({
  id,
  context: {
    cssPrefix,
  },
}) => {
  // Attach javascript to the head.
  useEffect(() => {
    if (document.getElementsByClassName('exco-player').length === 0) {
      // inject script only if it doesn't exist already
      const script = document.createElement('script');
      script.async = true;
      script.src = `//player.ex.co/player/${id}`;
      script.className = 'exco-player';
      document.head.appendChild(script);
    }
  }, [id]);

  return (
    <div className={`${cssPrefix}__digiteka`} id={id} />
  );
};

Digiteka.propTypes = {
  id: PropTypes.string.isRequired,
  context: PropTypes.shape({
    cssPrefix: PropTypes.string,
  }),
};

Digiteka.defaultProps = {
  context: {
    cssPrefix: 'polaris',
  },
};

export default compose(withPolaris)(Digiteka);
